export function StripeOverview() {
  return (
    <section className="p-4 rounded-lg bg-slate-core border border-white/10">
      <h2 className="font-medium text-ghost-white">Online billing retired</h2>
      <p className="mt-2 text-chromium-mist">
        Billing is managed directly. Contact <a href="mailto:stuart@nosible.com">stuart@nosible.com</a> for assistance.
        The remaining tabs show historical records stored in NOSIBLE.
      </p>
    </section>
  );
}
